import { Injectable, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
// import { MatDialog, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import Swal, { SweetAlertIcon, SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable()
export class ControlsService {

  public isHidden: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public statusProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public updateOC: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // display(value: boolean) {
  //   this.status.next(value);
  // }
  
  constructor(private dialog: MatDialog,
              private snackBar: MatSnackBar) { }

  openSpinner() {
    // this.statusProgress.next(true);
    // const spinner = this.dialog.open(SpinnerComponent, {
    //   disableClose: true,
    //   width: '150px',
    //   data: {}
    // });
    // // return false;
    // return spinner;
    //this.ngxService.start();
    // return false;
  }

  closeSpinner(spinner) {
    //this.ngxService.stop();
    // this.statusProgress.next(false);
    // setTimeout(() => {
    //   spinner.close(true);
    // });
  }

  private configSucces: MatSnackBarConfig = {
    panelClass: ['text-succes'],
    duration: 3500
  };

  private configError: MatSnackBarConfig = {
    panelClass: ['text-danger'],
    duration: 3500
  };

  public async msgSucces(message) {
    // this.snackBar.open(message, 'Cerrar', this.configSucces);
    await Swal.fire('Información', message, 'success');
    
  }

  public async msgCustom(message) {
    // this.snackBar.open(message, 'Cerrar', this.configSucces);
    await Swal.fire('Información', message, 'error');

  }
  public async msgInfo(message) {
    // this.snackBar.open(message, 'Cerrar', this.configError);
    await Swal.fire('Información', message, 'info');
  }

  public async msgWarning(message) {
    // this.snackBar.open(message, 'Cerrar', this.configError);
    await Swal.fire('', message, 'warning');
  }

  public async msgError(message) {
    // this.snackBar.open(message, 'Cerrar', this.configError);
    await Swal.fire('Error', message, 'error');
  }

  public async confirm(title: string, message: string, icon: SweetAlertIcon, callBack?: (value: SweetAlertResult) => void, 
                      confirmButtonText = 'Si', cancelButtonText = 'No') {
    await Swal.fire({
      title: title,
      text: message,
      icon: icon,
      focusConfirm: true,
      confirmButtonText,
      cancelButtonText,
      showCloseButton: true,
      showCancelButton: true
      // showConfirmButton: options.showConfirmButton,
      // showCloseButton: options.showCloseButton,
      // confirmButtonText: options.confirmButtonText || 'Ok',
      // cancelButtonText: options.cancelButtonText || 'Cerrar',
      ,
    }).then((result) => {
      if (result.value)
        callBack(result);
      // if (result.value) {
      //   eventConfirm();
      // } else if (result.dismiss === Swal.DismissReason.cancel) {
      //   if (eventCancel) {
      //     eventCancel();
      //   }
      // }
    });
  }

  public async toastSucces(message) {
    this.snackBar.open(message, 'Cerrar', this.configSucces);
  }

  public async toastInfo(message) {
    this.snackBar.open(message, 'Cerrar', this.configSucces);
  }

  public async toastWarning(message) {
    this.snackBar.open(message, 'Cerrar', this.configError);
  }

  public async toastError(message) {
    this.snackBar.open(message, 'Cerrar', this.configError);
  }

}
